import * as actionTypes from '../actions/actionTypes';

const initialState = {
    searchType: null,
    requests: {}
}

const reducer = (state = initialState, action) => {
    switch (action.type) {
        case actionTypes.SET_PERSISTED_SEARCH_REQUEST: {
            if (!action.searchType) {
                return state;
            }
            return {
                ...state,
                searchType: action.searchType,
                requests: {
                    ...state.requests,
                    [action.searchType]: action.request
                }
            }
        }
        case actionTypes.CLEAR_PERSISTED_SEARCH_REQUEST: {
            if (!action.searchType) {
                return state;
            }
            const requests = { ...state.requests };
            delete requests[action.searchType];
            return {
                ...state,
                searchType: state.searchType === action.searchType ? null : state.searchType,
                requests: requests
            }
        }
        case actionTypes.CLEAR_ALL_PERSISTED_SEARCH_REQUESTS:
        case actionTypes.LOGOUT_USER:
            return {
                ...initialState,
                requests: {}
            }
        default:
            return state;
    }
}

export default reducer;
